import { motion } from "framer-motion";
import { ExternalLink, Heart, Bookmark, ShoppingCart } from "lucide-react";

export default function AIGiftCard({ gift, index = 0, onSave }) {
  const sourceClassMap = {
    Amazon: "giftSourceAmazon",
    Etsy: "giftSourceEtsy",
    Uncommon: "giftSourceUncommon",
    Custom: "giftSourceCustom",
  };

  const getSourceClass = () => {
    const key = Object.keys(sourceClassMap).find((name) =>
      (gift.source || "").includes(name)
    );

    return key ? sourceClassMap[key] : "giftSourceDefault";
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      className="aiGiftCard"
    >
      <div className="aiGiftCardImage">
        {gift.image_url ? (
          <img src={gift.image_url} alt={gift.title || "Gift"} />
        ) : (
          <div className="aiGiftEmoji">{gift.emoji || "🎁"}</div>
        )}

        <div className="aiGiftSourceWrap">
          <span className={`aiGiftSource ${getSourceClass()}`}>
            {gift.source || "Gift"}
          </span>
        </div>

        {gift.match_reason && (
          <div className="aiGiftReasonOverlay">
            <p>{gift.match_reason}</p>
          </div>
        )}
      </div>

      <div className="aiGiftCardBody">
        <div>
          <h3>{gift.title}</h3>
          <p>{gift.description}</p>
        </div>

        <div className="aiGiftCardMeta">
          <span className="aiGiftPrice">{gift.price || "Flexible"}</span>

          {gift.emotional_score && (
            <div className="aiGiftMatch">
              <Heart size={14} />
              {gift.emotional_score}% match
            </div>
          )}
        </div>

        <div className="aiGiftActions">
          <button
            type="button"
            className="aiGiftBtn aiGiftBtnOutline"
            onClick={() => onSave?.(gift)}
          >
            <Bookmark size={15} />
            Save
          </button>

          {gift.link ? (
            <a
              href={gift.link}
              target="_blank"
              rel="noopener noreferrer"
              className="aiGiftBtn aiGiftBtnPrimary"
            >
              <ShoppingCart size={15} />
              Buy Now
            </a>
          ) : (
            <button type="button" className="aiGiftBtn aiGiftBtnPrimary">
              <ExternalLink size={15} />
              View
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
}